import { api } from '@/lib/api';
import type { DhlTrackingShipment, DhlRateResult, DhlServicePoint } from './types';

/**
 * Get DHL tracking data for multiple tracking numbers
 */
export async function getDhlTracking(
  trackingNumbers: string[],
): Promise<DhlTrackingShipment[]> {
  if (trackingNumbers.length === 0) return [];

  const cleaned = trackingNumbers.map((t) => t.replace(/\s/g, ''));
  return api.get<DhlTrackingShipment[]>('/v4/packing-slips/tracking/dhl', {
    trackingNumbers: cleaned.join(','),
  });
}

/**
 * Get DHL Express shipping rates
 */
export async function getDhlRates(
  params: Record<string, string | number | boolean>,
): Promise<DhlRateResult[]> {
  return api.get<DhlRateResult[]>('/v4/packing-slips/rates/dhl', params);
}

/**
 * Find DHL service points nearby
 */
export async function getDhlServicePoints(
  params: Record<string, string | number>,
): Promise<DhlServicePoint[]> {
  return api.get<DhlServicePoint[]>('/v4/packing-slips/service-points/dhl', params);
}
